import { apiFetch } from "@/auth/apiClient";
import type { EnrolledStudentRow } from "@/api/lms/courses";

export type CertificateDto = {
  id: string;
  courseId: string;
  courseTitle: string;
  courseDisplayTitle?: string;
  recipientDisplayName?: string;
  institutionName?: string;
  subtitle?: string;
  signatoryTitle?: string | null;
  template: string;
  grade: string | null;
  certificateNumber: string;
  issuedAt: string;
  /** Legacy / student list: resolved display name for UI */
  recipientName?: string;
  studentUserId?: number;
  studentName?: string;
  studentEmail?: string;
  issuedByEmail?: string;
  /** Mehul-template–specific fields */
  studentId?: string;
  dateOfBirth?: string;
  gender?: string;
  totalLessonHours?: string;
  attendance?: string;
  textBook?: string;
};

export type CertificateStudentSearchHit = {
  id: number;
  email: string;
  displayName: string;
  firstName: string | null;
  lastName: string | null;
};

export type CertificateUserEnrollment = {
  courseId: string;
  title: string;
  enrolledAt: string;
};

export async function getMyCertificates(): Promise<CertificateDto[]> {
  return apiFetch<CertificateDto[]>("/lms/certificates/me", { method: "GET", timeoutMs: 15000 });
}

export async function getAllCertificates(): Promise<CertificateDto[]> {
  return apiFetch<CertificateDto[]>("/lms/certificates", { method: "GET", timeoutMs: 15000 });
}

export async function issueCertificate(body: {
  userId: number;
  courseId: string;
  template: "classic" | "elegant" | "modern" | "mehul-1" | "mehul-2";
  recipientDisplayName: string;
  grade?: string;
  courseDisplayTitle?: string;
  institutionName?: string;
  subtitle?: string;
  signatoryTitle?: string;
  /** Mehul-template–specific fields */
  studentId?: string;
  dateOfBirth?: string;
  gender?: string;
  totalLessonHours?: string;
  attendance?: string;
  textBook?: string;
}): Promise<CertificateDto> {
  return apiFetch<CertificateDto>("/lms/certificates", { method: "POST", json: body });
}

export async function getCertificateCourseStudents(courseId: string): Promise<EnrolledStudentRow[]> {
  return apiFetch<EnrolledStudentRow[]>(`/lms/certificates/courses/${courseId}/students`, {
    method: "GET",
    timeoutMs: 15000,
  });
}

export async function searchCertificateUsers(q: string, limit = 25): Promise<CertificateStudentSearchHit[]> {
  const qs = new URLSearchParams({ q, limit: String(limit) });
  return apiFetch<CertificateStudentSearchHit[]>(`/lms/certificates/users/search?${qs.toString()}`, {
    method: "GET",
    timeoutMs: 15000,
  });
}

export async function getCertificateUserEnrollments(userId: number): Promise<CertificateUserEnrollment[]> {
  return apiFetch<CertificateUserEnrollment[]>(`/lms/certificates/users/${userId}/enrollments`, {
    method: "GET",
    timeoutMs: 15000,
  });
}
